import {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm, formValueSelector} from 'redux-form'

import CityTypeahead from '../../Form/Field/CityTypeahead.jsx'
import Date from '../../Form/Field/Date.jsx'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Input from '../../Form/Field/Input.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Quill from '../../Form/Field/Quill.jsx'

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import normBoolean from '../../Form/Normalizer/boolean.js'
import validate from './validate.js'

export const name = 'MissionForm'

class MissionForm extends Component {
  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Fonction exercée"
                name="title"
                type="text"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Entreprise"
                name="company"
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="C'est ma mission actuelle"
                name="current"
                type="checkbox"
                normalize={normBoolean}
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Date de début"
                name="start"
                dateFormat="MM/yyyy"
                placeholder="mm/aaaa"
                component={Date}
              />
            </div>
            {!this.props.isCurrent &&
              <div className="col-md-6">
                <Field
                  label="Date de fin"
                  name="end"
                  dateFormat="MM/yyyy"
                  placeholder="mm/aaaa"
                  component={Date}
                />
              </div>
            }
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                component={CityTypeahead}
                hasCountriesRestriction={false}
                label="Ville"
                name="locality"
                placeholder="Paris..."
                type="text"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {this.props.beautifying ? (
                <div className="form-group">
                  <label>Missions réalisées</label>
                  <div className="d-flex align-items-center justify-content-center border rounded" style={{ minHeight: 150 }}>
                    <svg style={{ width: 20, height: 20, animation: 'loader-rotate 1s linear infinite', marginRight: 8 }} viewBox="25 25 50 50">
                      <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="50 150" />
                    </svg>
                    Enrichissement en cours...
                  </div>
                </div>
              ) : (
                <Field
                  label="Missions réalisées"
                  name="description"
                  component={Quill}
                />
              )}
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    )
  }
}

let ReduxMissionForm = reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(MissionForm)

const selector = formValueSelector(name)

export default connect(
  state => ({
    isCurrent: selector(state, 'current')
  })
)(ReduxMissionForm)